export default '/coding/swagger-editor/C:/coding/swagger-editor/node_modules/.pnpm/web-tree-sitter@0.24.5/node_modules/web-tree-sitter'